import { FC } from 'react'
import { Box, Tooltip } from '@mui/material'
import { ClockIcon } from '@heroicons/react/24/solid'
import { ReportScheduleInfo } from 'models'
import { computeNextRun, formatScheduleDate, formatScheduleFrequency } from '../../reports-v2.utils'
import theme from 'theme'

interface ScheduleIndicatorProps {
  schedule: ReportScheduleInfo
}

const ScheduleIndicator: FC<ScheduleIndicatorProps> = ({ schedule }) => {
  const nextRun = computeNextRun(schedule.start_date, schedule.interval)
  const frequency = formatScheduleFrequency(schedule.interval)

  return (
    <Tooltip
      arrow
      placement="bottom-start"
      title={
        <Box>
          <Box>{`This report is generated ${frequency}.`}</Box>
          <Box>{`Next generation: ${formatScheduleDate(nextRun)}`}</Box>
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            padding: `${theme.spacing.md}px`,
            marginTop: `${theme.spacing.xSmall}px !important`,
            fontFamily: theme.typography.fontFamily.primary,
            fontSize: theme.typography.fontSize.medium,
            lineHeight: '140%',
            fontWeight: theme.typography.fontWeight.extraThick,
            color: theme.colors.menuItemText,
            borderRadius: theme.attributes.borderRadius.tertiary,
            boxShadow: '0px 4px 8px 0px rgba(30, 26, 29, 0.20)',
            background: theme.colors.tooltipBg
          }
        },
        arrow: {
          sx: { color: theme.colors.tooltipBg }
        }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: -8,
          right: -8,
          width: 24,
          height: 24,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: theme.colors.cta
        }}
      >
        <ClockIcon width={24} height={24} />
      </Box>
    </Tooltip>
  )
}

export default ScheduleIndicator
